import React, { forwardRef } from 'react'
import { View } from 'react-native'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type SecondaryIconButtonProps = Omit<BaseButtonProps, 'rightIcon' | 'buttonType' | 'text'> & {
  isSurvey?: boolean
}

export const SecondaryIconButton = forwardRef<React.ElementRef<typeof View>, SecondaryIconButtonProps>((props, ref) => {
  return (
    <BaseButton ref={ref} buttonType={props.isSurvey ? ButtonType.SURVEY_ICON : ButtonType.SECONDARY_ICON} {...props} />
  )
})
